import React from 'react';

const BundlePreviewModal = ({ show, bundle, onHide, onConfirm, teamPrimaryColor }) => {
    if (!show || !bundle) return null;

    const calculateBundleTotal = (bundle) => {
        if (!bundle || !bundle.optionBundleEntries) return 0;
        return bundle.optionBundleEntries.reduce((total, entry) => {
            return total + (entry.itemsOption.price * entry.quantity);
        }, 0);
    };

    const bundleTotal = calculateBundleTotal(bundle);

    return (
        <>
            <style>
                {`
                    @keyframes sparkle {
                        0%, 100% { opacity: 0.3; }
                        50% { opacity: 0.8; }
                    }
                    
                    @keyframes shimmer {
                        0% { background-position: -200% 0; }
                        100% { background-position: 200% 0; }
                    }
                    
                    @keyframes bounce {
                        0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
                        40% { transform: translateY(-5px); }
                        60% { transform: translateY(-3px); }
                    }
                `}
            </style>
            <div 
                className="modal fade show" 
                style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
                onClick={onHide}
            >
            <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                <div className="modal-content" style={{ border: 'none', borderRadius: '15px' }}>
                    <div className="modal-header bg-primary text-white" style={{ 
                        borderRadius: '15px 15px 0 0',
                        border: 'none',
                        position: 'relative',
                        overflow: 'hidden'
                    }}>
                        {/* Sparkle overlay effect */}
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'radial-gradient(circle at 20% 50%, rgba(255,215,0,0.2) 0%, transparent 20%), radial-gradient(circle at 80% 20%, rgba(255,255,255,0.1) 0%, transparent 15%), radial-gradient(circle at 70% 80%, rgba(255,215,0,0.15) 0%, transparent 18%)',
                            animation: 'sparkle 3s ease-in-out infinite'
                        }}></div>
                        
                        <h4 className="modal-title d-flex align-items-center" style={{ 
                            position: 'relative', 
                            zIndex: 1,
                            color: 'white',
                            textShadow: '2px 2px 4px rgba(0,0,0,0.5), 0 0 15px rgba(255,255,255,0.3)',
                            fontWeight: 'bold',
                            fontSize: '1.5rem'
                        }}>
                            <span style={{ 
                                fontSize: '1.5em', 
                                marginRight: '12px',
                                filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))',
                                animation: 'bounce 2s ease-in-out infinite'
                            }}>
                                {bundle.icon || '🎁'}
                            </span>
                            <span style={{
                                color: 'white',
                                textShadow: '2px 2px 4px rgba(0,0,0,0.5), 0 0 20px rgba(255,255,255,0.4)'
                            }}>
                                {bundle.name}
                            </span>
                        </h4>
                        <button 
                            type="button" 
                            className="btn-close btn-close-white" 
                            onClick={onHide}
                            aria-label="Close"
                        ></button>
                    </div>
                    
                    <div className="modal-body" style={{ padding: '2rem' }}>
                        {bundle.description && (
                            <div className="mb-4">
                                <p className="text-muted mb-0" style={{ 
                                    fontSize: '1.1rem', 
                                    lineHeight: '1.5',
                                    fontStyle: 'italic' 
                                }}>
                                    {bundle.description}
                                </p>
                            </div>
                        )}
                        
                        <div className="text-center p-4" style={{ 
                            background: 'linear-gradient(135deg, #f0f7ff, #e6f3ff)',
                            borderRadius: '15px',
                            border: '3px solid #0e456c',
                            position: 'relative',
                            overflow: 'hidden',
                            boxShadow: '0 8px 25px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.2)'
                        }}>
                            {/* Subtle shimmer effect for pricing section */}
                            <div style={{
                                position: 'absolute',
                                top: 0,
                                left: '-100%',
                                width: '100%',
                                height: '100%',
                                background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
                                animation: 'shimmer 3s ease-in-out infinite'
                            }}></div>
                            
                            <h4 style={{ 
                                color: '#0e456c',
                                margin: 0,
                                fontWeight: 'bold',
                                marginBottom: '0.5rem',
                                position: 'relative',
                                zIndex: 1,
                                textShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                fontSize: '1.8rem'
                            }}>
                                Starting at ${bundleTotal.toFixed(2)}
                            </h4>
                            <p className="text-muted mb-0" style={{ 
                                position: 'relative', 
                                zIndex: 1,
                                fontSize: '1.1rem',
                                fontWeight: '500'
                            }}>
                                {bundle.optionBundleEntries?.reduce((total, entry) => total + entry.quantity, 0) || 0} items included
                            </p>
                            <p className="text-muted mb-0 mt-2" style={{ 
                                position: 'relative', 
                                zIndex: 1,
                                fontSize: '0.95rem',
                                fontWeight: '400',
                                fontStyle: 'italic'
                            }}>
                                Add to view or edit items
                            </p>
                        </div>
                    </div>
                    
                    <div className="modal-footer" style={{ 
                        border: 'none',
                        padding: '1rem 2rem 2rem'
                    }}>
                        <button 
                            type="button" 
                            className="btn btn-outline-secondary me-2"
                            onClick={onHide}
                        >
                            Cancel
                        </button>
                        <button 
                            type="button" 
                            className="btn btn-primary btn-lg px-4"
                            onClick={() => onConfirm(bundle)}
                        >
                            Add This Bundle
                        </button>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default BundlePreviewModal;
